export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10205.10d58f61.jpg";